import React from 'react'
import '../Theme.css';
import Text from "../text/Text";
import Button from "../button/Button";
import './Dialog.css';
import Modal from "react-modal";
import Space from "../space/Space";

const Dialog = ({title, subtitle, image, visible, onPositiveClick, positiveText, onNegativeClick, negativeText}) => {
    const overlayStyle = {
        background: "#00000000",
        backdropFilter: 'blur(12px)',
    }
    const contentStyle = {
        background: "#06101d",
        border: 0,
        borderRadius: 32,
        width: "40%",
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    }

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onNegativeClick}
            style={{content: contentStyle, overlay: overlayStyle}}
            contentLabel="Modal">
            <div className="DialogRoot">
                <div className="DialogContent">
                    {image ? <img className="DialogImage" src={image} alt={"Coins"}/> : null}
                    <Text style={"DialogTitle"} text={title}/>
                    <Text style={"DialogSubtitle"} text={subtitle}/>
                    <div className="DialogButtons">
                        {onNegativeClick ?
                            <Button style={"PrimaryButton"} text={negativeText} onClick={onNegativeClick}/> : null}
                        {onPositiveClick && onNegativeClick ? <Space space={30}/> : null}
                        {onPositiveClick ?
                            <Button style={"AccentButton"} text={positiveText} onClick={onPositiveClick}/> : null}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default Dialog;
